import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import DevelopmentClientPage from '../components/DevelopmentClientPage'
import {
  actionCreators,
  IDevelopmentClientViewState,
  selectError,
  selectIsDeleting,
  selectIsLoading,
  selectItem,
  selectPermissions,
  selectScope,
  selectShowConfirmDelete,
} from '../modules/developmentClientDetail'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IDevelopmentClientViewState & ICurrentUserState
    >({
      error: selectError(),
      isDeleting: selectIsDeleting(),
      isLoading: selectIsLoading(),
      item: selectItem(),
      permissions: selectPermissions(),
      scope: selectScope(),
      showConfirmDelete: selectShowConfirmDelete(),
      user: selectCurrentUser(),
    }),
    actionCreators,
  )(DevelopmentClientPage),
)
